import { Divider } from "@material-ui/core";
import { AddLocation, Call, Email,Facebook,Twitter,Instagram } from "@material-ui/icons";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { colors } from "./../../res/values/values";
import useWindowWidthAndHeight from "../../utilities/hooks/useWindowWidthAndHeight";
const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  color: ${colors.whiteColor};
  background-color:${colors.darkcolor};
  justify-content: center;
  align-items:center;
  overflow: hidden;
  width: 100%;
 
`;

const Image = styled.img`
  object-fit: contain;
  height:5rem ;
  width: 5rem;
`;
const Top = styled.div`
  padding: 10px;
  display: flex;
  flex: 1;
  margin: 0 5px;
  justify-content: space-between;
  max-width: 1280px;
  flex-direction:column ;
  width: 90%;
  @media only screen and (min-width: 420px) {
    width: 100%;
    
    //margin: 0 40px;
  }
  @media only screen and (min-width: 600px) {
    flex-direction: row;
    //margin: 0 40px;
  }
  

`;
const ColumnList = styled.ul`
 
  list-style-type: none;
  margin-left: 10px;
  margin-right:10px ;
  padding: 0;
  cursor: pointer;
  display: flex !important;
  flex-direction: column;
  justify-content:center;
  @media only screen and (max-width: 600px) {
    width: 100%;
    //align-items: center;
    //text-align: center;
    //margin: 0 40px;
  }

`;
const ColumnListTitle = styled.li`
  font-size: 0.9375rem;
  //font-weight: 600;
  margin-bottom: 10px;
  letter-spacing: 1px;
  color: ${colors.secondryColor};
  @media only screen and (max-width: 768px) {
    font-size:  0.875rem;
  }
`;
const ColumnListItem = styled.li`
  margin-bottom: 5px;
  letter-spacing: 1px;
  display: flex;
  
  font-size: 0.875rem;
  @media only screen and (max-width: 768px) {
    
  }
  & a {
    font-size: 0.875rem;
    text-decoration: none;
  }
  & a:hover {
     color: ${colors.darkcolor}; 
  }
`;
const Bottom = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
    max-width: 1280px;
    padding:5px ;
    background-color: ${colors.darkcolor};
    text-align:center ;
    margin-top:1px ;
    & p {
      margin: 8px 0;
      color: #ffffff;
      font-size: .9em;
      @media only screen and (max-width: 768px) {
        font-size: .8em;
      }
      & a {
        color: #ffffff;
        font-size: .9em;
        text-decoration: none;
        @media only screen and (max-width: 768px) {
          font-size: .8em;
        }
      }
      & a:hover {
      color: ${colors.secondryColor}; 
      }
      
    }
    & img {
      object-fit: contain;
      height:34px ;
      width: 150px;
      margin-left: 1.5rem;
    }
    @media only screen and (max-width: 864px) {
      flex-direction: column;
      width: 100%;
      justify-content: center;
      align-items: center;
      margin-left: 0rem;
    }
`;
function Footer(props) {
  const navigate = useNavigate();
  const { width } = useWindowWidthAndHeight();
  return (
    <Container width={width}>
      <Top>
        <ColumnList>
          <Image onClick={(_) => navigate("/")}
                alt=""
                loading="lazy"
                title="homepagebanner"
                src={`./catalog/Products/logo.png`} />
          <ColumnListTitle>Best Catering Food Service</ColumnListTitle>
          <ColumnListItem>
            Unit 5-9 Leeside Industrial Estate
          </ColumnListItem>
          <ColumnListItem>
            Garman Road, Tottenham, N17 0QH London
          </ColumnListItem>
          <ColumnListItem>
            For media enquiries, call
          </ColumnListItem>
          <ColumnListItem>
            Phone: 020 888 555 94
          </ColumnListItem>
          <ColumnListItem>
            Fax: 020 888 554 09
          </ColumnListItem>
        </ColumnList>
        <ColumnList>
          <ColumnListTitle>Privacy & Terms</ColumnListTitle>
          <ColumnListItem onClick={(_) => navigate("/privacypolicy")}>
            Privacy Policy
          </ColumnListItem>
          <ColumnListItem onClick={(_) => navigate("/termsandconditions")}>
            Terms & Conditions
          </ColumnListItem>
          <ColumnListItem onClick={(_) => navigate("/faq")}>
            FAQ
          </ColumnListItem>
        </ColumnList>
        <ColumnList>
          <ColumnListTitle>Services</ColumnListTitle>
          
          <ColumnListItem onClick={(_) => navigate("/about")}>
            About Us
          </ColumnListItem>
          <ColumnListItem onClick={(_) => navigate("/contact")}>
            Contact Us
          </ColumnListItem>
        
        </ColumnList>
        <ColumnList>
          <ColumnListTitle>Follow Us</ColumnListTitle>
          <ColumnListItem>
            <a style={{color:"white"}} target="_blank" href="https://www.instagram.com/bestcateringuk/?hl=en">
              Instagram
            </a>
          </ColumnListItem>
          <ColumnListItem>
            <a style={{color:"white"}} target="_blank" href="https://www.facebook.com/bestcateringuk/">
              Facebook
            </a>
          </ColumnListItem>
        </ColumnList>
       
      </Top>
      <Divider style={{ margin: "5px 0" }} />

      <Bottom>
      <p>Powered By <a target="_blank" href="http://www.orcabs.com">Orca Business Solutions Ltd.  -  </a> Best Catering Food Services © 2024</p>
      <img alt="stripe"
          loading="lazy"
          title="stripe"
          src={`./images/payment_types.png`}/>
      <img alt="stripe"
          loading="lazy"
          title="stripe"
          src={`./images/stripe.svg`}/>
          
      </Bottom>
      <Divider style={{ margin: "5px 0" }} />
    </Container>
  );
}

export default Footer;
